import React, { Component } from 'react';
import countryList from 'react-select-country-list';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import actions from '../../../../redux/action';
import ToolsRender from './children/ToolsRender';
import { message } from 'antd';
import moment from 'moment';
import i18n from '../../../../../../locales/i18n';
import { GAPersonalProfilePageDisplay } from '../../../../ga/personalCenter';
import cartUrl from '@/views/account/utils/cartUrl';
import sentGAEvent from '../../../../ga/index';
class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countryList: countryList().getData(), //国家地区数组
      dataSource: [],
      changeInfoName: null, //用户当前修改的输入框名，用于显示提交按钮
      changeInfoLoading: false, //正在请求修改信息
      purchaseUrl: '/purchase',
    };
  }

  componentDidMount() {
    sentGAEvent({
      category: 'EnterPage',
      action: 'V2_EnterPage',
      label: 'V2ToolsPage',
    });
    if (window.location.href.indexOf('track[type]') >= 0) {
      // eslint-disable-next-line no-restricted-globals
      const urlParam = this.getUrlParam(location.href);
      const url = `&track[type]=${urlParam['track[type]']}&track[sid]=${urlParam['track[sid]']}&track[func]=${urlParam['track[func]']}&track[reason]=${urlParam['track[reason]']}&track[host]=${urlParam['track[host]']}&track[platform]=${urlParam['track[platform]']}&track[ab]=${urlParam['track[ab]']}&track[channel]=${urlParam['track[channel]']}&track[discount]=${urlParam['track[discount]']}`;
      this.setState({
        purchaseUrl: this.state.purchaseUrl + '?' + url,
      });
    } else {
      setTimeout(() => {
        const track = cartUrl('');
        let __s = Object.keys(track)
          .map((v) => {
            return `track[${v}]=${track[v]}`;
          })
          .join('&');
        this.setState({
          purchaseUrl: this.state.purchaseUrl + '?' + __s,
        });
      }, 1000);
    }
    GAPersonalProfilePageDisplay();
  }

  getUrlParam = (url) => {
    // 通过 ? 分割获取后面的参数字符串
    let urlStr = url.split('?')[1];
    // 创建空对象存储参数
    let obj = {};
    // 再通过 & 将每一个参数单独分割出来
    let paramsArr = urlStr.split('&');
    for (let i = 0, len = paramsArr.length; i < len; i++) {
      // 再通过 = 将每一个参数分割为 key:value 的形式
      let arr = paramsArr[i].split('=');
      obj[arr[0]] = arr[1];
    }
    return obj;
  };

  handleSubmitBtnHide = (form) => {
    if (!form.isFieldsTouched(true)) {
      this.setState({
        changeInfoName: null,
      });
    }
  };

  /**
   *控制当前修改的表单的值
   * @param {*} changeInfoName
   */
  handleChangeInfoName = (changeInfoName) => {
    this.setState({
      changeInfoName,
    });
  };

  render() {
    return (
      <>
        <ToolsRender />
      </>
    );
  }
}

const mapStateToPropos = (state) => ({
  profileObj: state.account.profileObj,
  subscription: state.account.subscription,
});
const mapDispatchToProps = (dispatch) => ({
  onProfileObjChange: (profileObj) =>
    dispatch(actions.onProfileObjChange(profileObj)),
});

export default connect(
  mapStateToPropos,
  mapDispatchToProps
)(withTranslation(['common'])(Profile));
